import { useTranslation } from "react-i18next";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import Hero from "./components/Hero";
import JumpSection from "./components/JumpSection";
import AboutSections from "./components/AboutSections";
import CategorySection from "./components/CategorySection";
import SafetySection from "./components/SafetySection";
import ArticleSection from "./components/ArticleSection";
import FaqSection from "./components/FaqSection";
import JsonLd from "@/components/seo/JsonLd";
import { SITE_URL, SITE_LOGO_URL } from "@/components/seo/siteUrl";

export default function Home() {
  const { t, i18n } = useTranslation();

  const faqs = [1, 2, 3, 4, 5, 6, 7, 8].map((n) => ({
    q: t(`faq.q${n}`),
    a: t(`faq.a${n}`),
  }));

  const webSiteSchema: Record<string, unknown> = {
    "@context": "https://schema.org",
    "@type": "WebSite",
    name: "USFans Spreadsheet",
    url: SITE_URL,
    inLanguage: "en",
    description:
      "USFans Spreadsheet resources, practical guides, seller information, comparisons, shipping insights and safety tips.",
  };

  const organizationSchema: Record<string, unknown> = {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: "USFans Spreadsheet",
    url: SITE_URL,
    logo: SITE_LOGO_URL,
  };

  const faqSchema: Record<string, unknown> = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    inLanguage: i18n.language,
    mainEntity: faqs.map((f) => ({
      "@type": "Question",
      name: f.q,
      acceptedAnswer: { "@type": "Answer", text: f.a },
    })),
  };

  return (
    <div className="min-h-screen bg-background-50">
      <JsonLd data={webSiteSchema} />
      <JsonLd data={organizationSchema} />
      <JsonLd data={faqSchema} />
      <Navbar />
      <main>
        <Hero />
        <JumpSection />
        <AboutSections />
        <CategorySection />
        <SafetySection />
        <ArticleSection />
        <FaqSection />
      </main>
      <Footer />
    </div>
  );
}